import React from 'react';
import PropTypes from 'prop-types';

import HeaderBox from '../header-box';
import './items-grid.css';

const ItemsGrid = ({ children, copy, header }) => (
    <div className="items-grid">
        {(copy || header) && <HeaderBox copy={copy} header={header} />}
        <div className="grid-container">{children}</div>
    </div>
);

ItemsGrid.defaultProps = {};

ItemsGrid.propTypes = {
    children: PropTypes.node.isRequired,
    copy: PropTypes.string,
    header: PropTypes.string,
};

export default ItemsGrid;
